<template>
  <fragment>
    <p class="text-muted text-center" v-if="!entity || entity.length==0">
      <i class="feather icon-search display-4 d-block m-3"></i>
       - Nessuna risorsa trovata -
    </p>
    <div class="row" v-if="entity">
      <div class="col-12">
        <div class="media" v-for="item in entity">
          <div class="media-body">
            <h5 class="mt-0 font-16">{{getDescription(item.code)}}</h5>
            <span v-if="item.value">
            {{item.value}}
            </span>
              <span v-if="item.dateValue">
            {{item.dateValue | formatDate}}
            </span>
             <span v-if="item.floatValue">
            {{item.floatValue}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>
<script>
import axios from "axios";
export default {
  name: "oneInformation",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      entity: null,
      descriptions:[]
    };
  },
  methods: {
    getDescription(code) {
      for(var i=0; i< this.descriptions.length; i++){
        if(this.descriptions[i].code == code)
        return  this.descriptions[i].value

      }
     return code;
    },
  },

  beforeMount() {
    /*   var me = this;
            
           
*/
    let me = this;
    me.$nextTick(function () {
 axios.get(`backofficeinformation/descriptions`).then((response) => {
        me.descriptions = response.data;
     


      axios.get(`backofficeinformation/${me.value}`).then((response) => {
        me.entity = response.data;
      });
       });
    });
  },
};
</script>
